import update from "../../node_modules/immutability-helper";

export const updateArrayByItemProp = <T extends { [key: string]: any }, V>(
	arr: T[],
	propName: string,
	propVal: V,
	newItem: T
): T[] => {
	const updatedArr = [...arr];
	const targetIndex = arr.findIndex((val: T) => val[propName] === propVal);

	if (targetIndex > -1) {
		Object.assign(updatedArr[targetIndex], newItem);
	} else {
		updatedArr.push(newItem);
	}

	return updatedArr;
};

export const setOrInsertArrayItemByProp = <T extends { [key: string]: any }, V>(
	arr: T[],
	propName: string,
	propVal: V,
	newItem: T
): T[] => {
	const targetIndex = arr.findIndex((val: T) => val[propName] === propVal);

	if (targetIndex > -1) {
		return update(arr, {
			[targetIndex]: {
				$set: newItem
			}
		});
	} else {
		return update(arr, {
			$push: [newItem]
		});
	}
};

export const mergeArraysByItemProp = <T extends { [key: string]: any }, V>(
	original: T[],
	propName: string,
	newItems: T[]
): T[] => {
	let newOriginal = [...original];

	newItems.forEach(newItem => {
		newOriginal = setOrInsertArrayItemByProp(
			newOriginal,
			propName,
			newItem[propName],
			newItem
		);
	});

	return newOriginal;
};

export const sortObjectKeys = <K extends { [index: string]: any }>(obj: K) => {
	return Object.keys(obj)
		.sort()
		.reduce((a: K, k: string) => {
			a[k] = obj[k];

			return a;
		}, {});
};

export const objectMatches = (targetObj: object, subject: object) => {
	return (
		JSON.stringify(sortObjectKeys(targetObj)) ===
		JSON.stringify(sortObjectKeys(subject))
	);
};
